module.exports = {
  title: 'Vue Element Admin',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  footer: [
    {name: '联系人', text: '包双柱'},
    {name: 'Email', text: '83956411@qq.com'},
    {name: '电话', text: '19969017305'},
    {name: '全国热线', text: '0471 5206789'},
    {name: '地址', text: '内蒙古自治区呼和浩特市赛罕区兴安路中海蓝湾财富广场一期6层E段604'}
  ],
  mn_footer: [{
    name: 'ᠬᠠᠷᠢᠯᠴᠠᠬᠤ ᠬᠥᠮᠦᠨ᠄',
    text: 'ᠪᠤᠤ ᠱᠤᠸᠠᠩ ᠵᠦ᠍'
  },
  {
    name: 'ᠢᠮᠸᠯ᠄',
    text: '83956411@qq.com'
  },
  {
    name: 'ᠤᠳᠠᠰᠤ᠄',
    text: '19969017305'
  },
  {
    name: ' ᠬᠠᠯᠠᠭᠤᠨ ᠤᠲᠠᠰᠤ᠄ ',
    text: '0471 5206789'
  },
  {
    name: 'ᠪᠠᠢᠭ᠎ᠠ ᠭᠠᠵᠠᠷ᠄',
    text: ' ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤ᠋ᠨ  ᠦᠪᠡᠷᠲᠡᠭᠡᠨ ᠵᠠᠰᠠᠬᠤ ᠤᠷᠤᠨ ᠦ᠌ ᠬᠦᠬᠡᠬᠤᠲᠠ ᠶ᠋ᠢᠨ ᠰᠠᠢᠬᠠᠨ ᠲᠤᠭᠤᠷᠢᠭ ᠤ᠋ᠨ ᠬᠢᠩᠭᠠᠨ ᠡᠮᠦᠨ᠎ᠡ ᠵᠠᠮ ᠳᠡᠬᠢ ᠵᠦᠩ ᠬᠠᠢ ᠯᠠᠨ ᠸᠠᠨ ᠼᠠᠢ ᠹᠦ ᠲᠠᠯᠠᠪᠠᠢ ᠶ᠋ᠢᠨ E ᠰᠠᠭᠤᠷᠢ ᠶ᠋ᠢᠨ 604'
  }
  ],
  cgalList: [
    [{id: 1, name: '融媒体资源生产发布平台'},
      {id: 2, name: '多文种教学资源管理平台'},
      {id: 3, name: '网络热点分析系统'},
      {id: 4, name: '多语种信息处理平台'}],
    [
      {id: 5, name: '医院多语种叫号系统'},
      {id: 6, name: '多文种法律法规库'},
      {id: 7, name: '网上诉讼平台'},
      {id: 8, name: '作业与组卷管理系统'}
    ]
  ],
  mncgalList: [
    [{id: 1, name: 'ᠬᠠᠮ ᠵᠠᠭᠤᠴᠢᠯᠠᠭᠤᠷ\n᠎ᠤᠨ ᠡᠬᠢ ᠰᠤᠷᠪᠤᠯᠵᠢ᠎ᠶᠢ ᠦᠢᠯᠡᠳᠪᠦᠷᠢᠯᠡᠨ ᠨᠡᠢᠳᠡᠯᠡᠬᠦ ᠲᠠᠪᠴᠠᠩ'},
      {id: 2, name: 'ᠤᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠵᠢᠭᠠᠨ ᠰᠤᠷᠭᠠᠯᠲᠠ᠎ᠶᠢᠨ ᠡᠬᠢ ᠪᠠᠶᠠᠯᠢᠭ᠎ᠢ ᠬᠠᠮᠢᠶᠠᠷᠬᠤ ᠲᠠᠪᠴᠠᠩ'},
      {id: 3, name: 'ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷᠡᠬᠢ ᠬᠠᠯᠠᠮᠰᠢᠯ ᠠᠭᠤᠯᠭ᠎ᠠ᠎ᠶᠢ ᠵᠠᠳᠠᠯᠤᠬᠤ ᠲᠠᠪᠴᠠᠩ'},
      {id: 4, name: 'ᠤᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠵᠠᠩᠭᠢ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠲᠠᠪᠴᠠᠩ'}],
    [
      {id: 5, name: 'ᠡᠮᠨᠡᠯᠭᠡ᠎ᠶᠢᠨ ᠬᠣᠷᠢᠶᠠᠨ᠎ᠤ ᠤᠯᠠᠨ ᠬᠡᠯᠡ ᠪᠡᠷ ᠳ᠋ᠤᠭᠠᠷ ᠳᠠᠭᠤᠳᠠᠬᠤ ᠰᠢᠰᠲ᠋ᠧᠮ'},
      {id: 6, name: 'ᠤᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠬᠠᠤᠯᠢ ᠴᠠᠭᠠᠵᠠ ᠬᠠᠤᠯᠢ ᠳᠦᠷᠢᠮ᠎ᠤᠨ ᠬᠦᠮᠦᠷᠭᠡ'},
      {id: 7, name: 'ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷ᠎ᠡ ᠵᠠᠷᠭᠤ ᠬᠢᠬᠦ ᠲᠠᠪᠴᠠᠩ'},
      {id: 8, name: 'ᠳᠠᠰᠭᠠᠯ ᠪᠠ ᠰᠢᠯᠭᠠᠯᠲᠠ ᠡᠭᠦᠰᠭᠡᠬᠦ ᠬᠠᠮᠢᠶᠠᠷᠤᠯᠲᠠ<br>᠎ᠶᠢᠨ ᠰᠢᠰᠲ᠋ᠧᠮ'}
    ]
  ],
  fwkhList: [
    [
      {id: 1, name: '内蒙古日报社'},
      {id: 2, name: '内蒙古电视台'},
      {id: 4, name: '内蒙古自治区公安厅'}
    ],
    [
      {id: 5, name: '内蒙古自治区高级人民法院'},
      {id: 6, name: '呼和浩特呼铁局'},
      {id: 8, name: '兴安盟教育局'}
    ]
  ],
  mnfwkhList: [
    [
      {id: 1, name: 'ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤ᠋ᠨ ᠡᠳᠦᠷ ᠤ᠋ᠨ ᠰᠣᠨᠢᠨ'},
      {id: 2, name: 'ᠥᠪᠥᠷ ᠮᠤᠨᠭᠭᠤᠯ ᠦ᠋ᠨ ᠲᠸᠯᠸᠢᠰ ᠬᠣᠷᠢᠶ᠎ᠠ'},
      {id: 4, name: ' ᠥᠪᠥᠷ ᠮᠤᠨᠭᠭᠤᠯ ᠤ᠋ᠨ ᠥᠪᠡᠷᠲᠡᠭᠡᠨ ᠵᠠᠰᠠᠬᠤ ᠣᠷᠣᠨ ᠤ᠋ ᠠᠮᠤᠷ ᠢ᠋ ᠬᠠᠮᠠᠭᠠᠯᠠᠬᠤ ᠲᠢᠩᠭᠢᠮ '}
    ],
    [
      {id: 5, name: 'ᠥᠪᠥᠷ ᠮᠤᠩᠭᠤᠯ ᠤ᠋ᠨ ᠦᠪᠡᠷᠲᠡᠭᠡᠨ ᠵᠠᠰᠠᠬᠤ ᠤᠷᠤᠨ ᠤ᠋ ᠠᠷᠠᠳ ᠤ᠋ᠨ ᠦᠨᠳᠦᠷ ᠵᠡᠷᠭᠡ ᠶ᠋ᠢᠨ ᠰᠢᠭᠦᠬᠦ ᠬᠤᠷᠢᠶ᠎ᠠ'},
      {id: 6, name: 'ᠬᠦᠬᠡᠬᠤᠳᠠ ᠶ᠋ᠢᠨ ᠲᠡᠮᠦᠷ ᠵᠠᠮ ᠤ᠋ᠨ ᠲᠣᠪᠴᠢᠶ᠎ᠠ'},
      {id: 8, name: 'ᠬᠢᠨᠭᠭᠠᠨ ᠠᠢᠮᠠᠭ ᠤ᠋ᠨ ᠰᠤᠷᠭᠠᠨ ᠬᠥᠮᠦᠵᠢᠯ ᠤ᠋ᠨ ᠲᠣᠪᠴᠢᠶ᠎ᠠ'}
    ]
  ],
  jsfw: {
    list: [
      {id: 1, name: '校正服务'},
      {id: 2, name: '中蒙互译<br />服务'},
      {id: 3, name: '西里尔蒙古文与传 统蒙古文互转服务'},
      {id: 4, name: 'OCR服务'},
      {id: 5, name: '编码转换服务'},
      {id: 6, name: '在线词典服务'},
      {id: 7, name: '网络信息<br />检索服务'},
      {id: 8, name: '语音合成服务'},
      {id: 9, name: '语音识别服务'}

    ],
    content: '公司立足边疆少数民族地区，以服务自治区经济社会发展为己任，以创新的精神和务实的态度研发和推广智能多语种信息处理相关产品，围绕人工智能、大数据、云计算、智慧城市等领域，采用最新互联网和深度学习技术，有效整合自治区政府部门和企业数据和服务资源，为全国少数民族智能信息处理和相关技术研发提供定制开发服务。'
  },
  mnjsfw: {
    list: [
      {id: 1, name: 'ᠠᠦ᠋ᠲ᠋ᠤ᠋ ᠵᠠᠯᠠᠷᠠᠭᠤᠯᠬᠤ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 2, name: 'ᠮᠠᠰᠢᠨ ᠣᠷᠴᠢᠭᠤᠯᠭ᠎ᠠ᠎ᠶᠢᠨ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 3, name: 'ᠺᠢᠷᠢᠯ᠂ ᠣᠯᠠᠮᠵᠢᠯᠠᠯᠲᠤ ᠬᠠᠷᠢᠯᠴᠠᠨ ᠪᠠᠭᠤᠯᠭᠠᠬᠤ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 4, name: 'OCR ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 5, name: ' ᠺᠣᠳ᠋ ᠬᠦᠷᠪᠡᠭᠦᠯᠬᠦ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 6, name: ' ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷᠡᠬᠢ ᠲᠣᠯᠢ ᠪᠢᠴᠢᠭ ᠦ᠋ᠨ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 7, name: 'ᠰᠦᠯᠵᠢᠶᠡᠨ ᠳᠡᠭᠡᠷᠡᠬᠢ ᠵᠠᠩᠭᠢ ᠰᠤᠷᠠᠬᠤ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 8, name: 'ᠠᠪᠢᠶ᠎ᠠ ᠨᠡᠢᠯᠡᠭᠦᠯᠬᠦ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'},
      {id: 9, name: ' ᠠᠪᠢᠶ᠎ᠠ ᠵᠢ ᠢᠯᠭᠠᠨ ᠲᠠᠨᠢᠬᠤ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'}

    ],
    content: 'ᠮᠠᠨ᠎ᠤ ᠺᠣᠮᠫᠠᠨᠢ ᠴᠥᠭᠡᠨ ᠲᠣᠭᠠᠲᠤ ᠦᠨᠳᠦᠰᠦᠲᠡᠨ᠎ᠴᠤᠭᠯᠠᠷᠠᠨ ᠰᠠᠭᠤᠷᠢᠰᠢᠭᠰᠠᠨ ᠬᠢᠯᠢ ᠭᠠᠵᠠᠷ᠎ᠡᠴᠡ ᠰᠠᠭᠤᠷᠢᠯᠠᠨ᠂ ᠥᠪᠡᠷᠲᠡᠭᠡᠨ ᠵᠠᠰᠠᠬᠤ ᠣᠷᠣᠨ᠎ᠤ᠋ ᠠᠵᠤ ᠠᠬᠤᠢ ᠨᠡᠢᠭᠡᠮ᠎ᠦ᠋ᠨ ᠬᠥᠭᠵᠢᠯᠲᠡ᠎ᠳ᠋ᠦ᠍ ᠦᠢᠯᠡᠴᠢᠯᠡᠬᠦ᠎ᠪᠡᠷ ᠥᠪᠡᠷ᠎ᠦ᠋ᠨ ᠡᠭᠦᠷᠭᠡ᠎ᠪᠡᠨ ᠪᠣᠯᠭᠠᠵᠤ᠂ ᠰᠢᠨ᠎ᠡ᠎ᠶ᠋ᠢ ᠡᠭᠦᠳᠬᠦ ᠵᠣᠷᠢᠭ ᠰᠠᠨᠠᠭ᠎ᠠ ᠪᠠ ᠪᠣᠳᠠᠲᠠᠢ᠎ᠶ᠋ᠢ ᠡᠷᠬᠢᠮᠯᠡᠬᠦ ᠣᠪᠣᠷ᠎ᠢᠶ᠋ᠠᠷ ᠣᠶᠤᠨᠲᠤ ᠣᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠦ᠌ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ᠎ᠶ᠋ᠢ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠬᠠᠮᠢᠶ᠎ᠠ ᠪᠦᠬᠦᠢ ᠦᠢᠯᠡᠳᠬᠦᠨ᠎ᠢ᠋ ᠰᠤᠳᠤᠯᠤᠨ ᠨᠡᠭᠡᠭᠡᠬᠦ ᠪᠠ ᠳᠡᠯᠭᠡᠷᠡᠭᠦᠯᠵᠦ ᠂ ᠬᠢᠮᠡᠯ ᠣᠶᠤᠨ᠂ ᠲᠣᠮᠣ ᠳ᠋ᠠᠢᠲ᠋ᠠ᠂ ᠡᠭᠦᠯᠡᠨ ᠪᠣᠳᠣᠯᠲᠠ᠂ ᠤᠶᠤᠨᠯᠢᠭ ᠬᠣᠲᠠ ᠵᠡᠷᠭᠡ ᠬᠦᠷᠢᠶᠡᠨ᠎ᠳ᠋ᠤ᠌᠂ ᠬᠠᠮᠤᠭ᠎ᠤ᠋ᠨ ᠰᠢᠨ᠎ᠡ ᠢᠨᠲ᠋ᠧᠷ ᠰᠦᠯᠵᠢᠶ᠎ᠡ᠎ᠶᠢᠨ ᠪᠠ ᠭᠦᠨ ᠰᠤᠷᠤᠯᠴᠠᠬᠤ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠢ᠋ ᠬᠡᠷᠡᠭᠯᠡᠨ᠂ ᠥᠪᠡᠷᠲᠡᠭᠡᠨ ᠵᠠᠰᠠᠬᠤ ᠣᠷᠣᠨ᠎ᠤ᠋ ᠵᠠᠰᠠᠭ᠎ᠤ᠋ᠨ ᠣᠷᠳᠣᠨ᠎ᠤ᠋ ᠰᠠᠯᠠᠭ᠎ᠠ ᠮᠥᠴᠢᠷ ᠪᠠ ᠠᠵᠤ ᠠᠬᠤᠢᠯᠠᠯ᠎ᠤ᠋ᠨ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠪᠠ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡᠨ᠎ᠦ᠌ ᠡᠬᠢ ᠪᠠᠶᠠᠯᠢᠭ᠎ᠢ᠋ ᠪᠦᠲᠦᠮᠵᠢᠲᠡᠢ ᠡᠮᠬᠢᠯᠡᠨ ᠨᠡᠢᠯᠡᠭᠦᠯᠵᠦ᠂ ᠪᠦᠬᠦ ᠤᠯᠤᠰ᠎ᠤ᠋ᠨ ᠴᠥᠭᠡᠨ ᠲᠣᠭᠠᠲᠤ ᠦᠨᠳᠦᠰᠦᠲᠡᠨ᠎ᠦ᠌ ᠣᠶᠤᠨᠲᠤ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ᠎ᠶ᠋ᠢ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠪᠠ ᠬᠠᠮᠢᠶ᠎ᠠ ᠪᠦᠬᠦᠢ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠢ᠋ ᠰᠤᠳᠤᠯᠤᠨ ᠨᠡᠭᠡᠭᠡᠬᠦ᠎ᠳ᠋ᠦ᠍ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ ᠬᠠᠨᠭᠭᠠᠳᠠᠭ᠃'
  },
  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}



// WEBPACK FOOTER //
// ./src/settings.js